const esMessages = {
  'HomePage:Text:Body2': `
    <h4>🍺 Una nueva etapa para la comunidad cervecera</h4>
    <p>La Copa de las Californias nace del espíritu colaborativo de la escena cervecera regional. Tras años de crecimiento y convivencia con el Pizza & Cheve Fest, la comunidad de cerveceros decidió dar un paso más allá.</p>
    <p>¿El resultado? Un festival internacional, competitivo y cultural que busca celebrar lo mejor de las cervezas artesanales de las dos Californias mexicanas y la California estadounidense, en un mismo punto de encuentro: La Paz, Baja California Sur.</p>
    <h4>🌱 Evolución con propósito</h4>
    <p>Este nuevo formato es más que un cambio de nombre.</p>
    <p>Es la evolución natural de un movimiento que ha madurado:</p>
    <ul>
      <li>Muchos miembros del Club de Cerveceros de BCS se están certificando como jueces BJCP.</li>
      <li>La comunidad impulsa la calidad, el profesionalismo y la creatividad.</li>
      <li>La competencia está diseñada con rigor y pasión cervecera.</li>
    </ul>
    <h4>🇲🇽 🇺🇸 Una copa. Tres regiones. Un mismo espíritu.</h4>
    <p>Más de 40 cervecerías independientes compiten por el reconocimiento del público y los jueces.</p>
    <p>Desde Tijuana hasta San Diego, pasando por Ensenada, Mulegé y Los Cabos, esta copa es el punto de encuentro para probar, aprender y celebrar.</p>
    <h4>📍 La Paz, B.C.S.</h4>
    <p>Con el mar de fondo y el alma cervecera al frente.</p>
    <p>El Malecón de La Paz será el escenario de esta fiesta sensorial:</p>
    <p>cerveza, música, gastronomía y comunidad en un entorno único.</p>
    <ul>
      <li>🎉 Muy pronto: Copa de las Californias 2025</li>
      <li>🗓️ Fecha por anunciar</li>
      <li>📍 Malecón Costero, La Paz, B.C.S.</li>
      <li>🥇 Competencia oficial BJCP</li>
      <li>🍕 Herencia del Pizza & Cheve Fest</li>
    </ul>
  `,
  'HomePage:Text:Body3': `
    <p>La copa reúne a más de 40 cervecerías independientes que representan la diversidad cervecera de las tres Californias.</p>
    <p>🔥 Compiten en estilos como:</p>
    <ul>
    <li>IPA  / Hazy IPA</li>
    <li>Stout, Porter y cervezas oscuras</li>
    <li>Lagers, Pale Ale, Amber y más</li>
    </ul>
  `,
  'HomePage:Text:Body4': `
    <p>Imágenes de los festivales que nos inspiraron:</p>
    <p><b>Ceviche Fest, Baja Soul Fest y Pizza & Cheve Fest.</b></p>
    <p>Eventos que abrieron camino a lo que hoy es la Copa de las Californias.</p>
    <p>Explora la evolución de nuestra comunidad en cada foto.</p>
  `,
  'HomePage:Text:Body5': `
    <p>Forma parte del evento cervecero más importante del Pacífico. Ya seas cervecería, medio o colaborador, este es tu espacio.</p>
  `,
  'HomePage:Text:Body6': `
  <h4>🍻 ¿Eres cervecería?Regístrate para competir</h4>
  <p>La Copa de las Californias es una vitrina internacional para que tu cerveza destaque frente a colegas y público conocedor.</p>
  <p>Participan cervecerías de Baja California, Baja Sur y California, EE.UU., compitiendo en estilos evaluados por jueces certificados BJCP.</p>
  <p>Además del concurso, podrás tener tu propio stand en el festival, donde miles de asistentes podrán conocer y disfrutar tus estilos.</p>
  <p>✅ Cupo limitado | ✅ Reglas claras | ✅ Visibilidad real</p>
  <h5>👉 Regístrate como cervecería participante</h5>
  `,
  'HomePage:Text:Body7': `
    <h4>¿Eres parte de un medio, influencer gastronómico o te interesa colaborar con la experiencia del festival?</h4>
    <p>Buscamos aliados creativos, comprometidos y apasionados por la cerveza artesanal, la cultura y la comunidad.</p>
    <p>Ya sea para cobertura, alianzas comerciales o propuestas culturales, queremos escucharte.</p>
    <ul>
      <li>🎤 Cobertura de prensa</li>
      <li>🎨 Activaciones y experiencias</li>
      <li>📢 Alianzas de marca</li>
    </ul>
    <h5>👉 Solicita tu acreditación o envíanos tu propuesta</h5>
  `,
  'HomePage:Text:Body8': `
    <h4>🧑‍⚖️ Jueces invitados internacionales</h4>
    <p>Este año, la Copa de las Californias contará con la presencia de dos figuras clave del mundo cervecero, ambos miembros del Beer Judge Certification Program (BJCP):</p>
  `,
  'HomePage:Text:Body9': `
    <h5>👨‍🔬 John Palmer</h5>
    <p>Autor de How to Brew, una de las guías más influyentes en la elaboración de cerveza a nivel mundial. Referente técnico y formador de cientos de cerveceros artesanales.</p>
  `,
  'HomePage:Text:Body10': `
    <h5>👩‍🏫 Sandy Cockerham</h5>
    <p>Jueza BJCP con más de 15 años en competencias internacionales. Reconocida por su enfoque sensorial y su trabajo en la promoción de mujeres dentro del mundo cervecero.</p>
  `,
  'HomePage:Text:CallToAction01': 'Formar Parte',
  'HomePage:Text:CallToAction02': 'Ver detalles del festival',
  'HomePage:Text:CallToAction03': 'Quiero competir (Pro)',
  'HomePage:Text:CallToAction04': 'Quiero competir (Amateur)',
  'HomePage:Text:CallToAction05': 'Quiero colaborar',
  'HomePage:Text:Heading1': 'Tres regiones. Una pasión: la cerveza artesanal',
  'HomePage:Text:Heading2': '🏆 Copa de las Californias 2025',
  'HomePage:Text:Heading3': 'Los cerveceros que hacen historia',
  'HomePage:Text:Heading4': '📸 Galería',
  'HomePage:Text:Heading5': '🤝 Participa en la Copa de las Californias',
  'HomePage:Text:Subheading1': 'Por primera vez, los sabores, estilos y talentos de las tres Californias se enfrentan en un festival donde el lúpulo, la malta y la creatividad serán los protagonistas',
  'HomePage:Text:Support': '🏆 Copa de las Californias',
  'MainFooter:Text:Rights': 'Copa de las Californias. Todos los derechos reservados',
  'MainHeader:Link:Fest': 'Festival',
  'MainHeader:Link:Brewers': 'Cerveceros',
  'MainHeader:Link:Gallery': 'Galería',
  'MainHeader:Link:TakePart': 'Forma Parte',
  'NotFoundPage:Alt:Error': 'Error 404',
  'NotFoundPage:Heading:Error': 'Error 404: Página no encontrada',
  'NotFoundPage:Description:Error': 'La página que estás buscando no está disponible. Por favor, verifica la URL e intenta nuevamente',
};

export default esMessages;
